import React from 'react';

const useAbortController = () => {
	return React.useState(() => {
		return typeof window !== 'undefined' ? new AbortController() : { signal: undefined, abort: (reason?: string) => undefined };
	});
};

export default useAbortController;
